// @flow
import React from 'react';
import { DataUtils } from 'common/utils/DataUtils';
import NumberUtils from 'common/utils/NumberUtils';
import TimeUtils from 'common/utils/TimeUtils';

const resourceLimitCellFactory = (
    type: string,
    threshType: string,
    getLimits: Function,
    showOnlyValue?: boolean
) => {
    return props => {
        const {
            original,
            tdProps: {
                rest: { unitConverter }
            }
        } = props;

        const limits = getLimits(original);
        if (limits) {
            const resource = limits[type];
            if (!DataUtils.isEmpty(resource?.[threshType])) {
                let value = limits.getPreferredValue({
                    value: resource[threshType],
                    unitConverter,
                    type
                });
                value = NumberUtils.roundOff(value);
                if (showOnlyValue) {
                    return value;
                }
                const unit = limits.getPreferredUnitText(unitConverter, type);
                return <span>{`${value} ${unit}`}</span>;
            }
        }
        return <span>{'-'}</span>;
    };
};

const getTransactionTimePerTask = (transactionTimePerTask: ?number) => {
    if (!NumberUtils.isNumeric(transactionTimePerTask)) {
        return '-';
    }
    return TimeUtils.humanizeSeconds(Number(transactionTimePerTask), {
        largest: 2
    });
};

export { resourceLimitCellFactory, getTransactionTimePerTask };
